import {useTranslation} from '@/translations/i18n'
import {Text} from '@/components/ui/text/Text'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {DetailsField} from '@/components/ui/details-atoms/DetailsAtoms'
import {HttpGetProjectClinicalPresentationsResponse} from '../../http/projects.http'
import {clinicalPresentationToLabel, stabilityLevelToLabel, careNeedToLabel} from '../../utils'
import {Divider} from '@/components/ui/divider/Divider'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

interface ClinicalRecordCardViewProps {
    clinicalRecord: HttpGetProjectClinicalPresentationsResponse
}
export const ClinicalPresentationsCardView = ({clinicalRecord}: ClinicalRecordCardViewProps) => {
    const {t} = useTranslation()

    return (
        <Grid columns={3} gap={3} fullWidth>
            <Flexbox direction="column" gap={2} fullWidth justify="space-between">
                <DetailsField fullWidth>
                    <Text palette="neutral" shade="500" size="textSm">
                        {t('projects:cognitive_disorders')}
                    </Text>
                    <Text palette="neutral" shade="950" size="textSm" weight="500">
                        {clinicalRecord.cognitiveDisorders
                            ? t(clinicalPresentationToLabel[clinicalRecord.cognitiveDisorders])
                            : '-'}
                    </Text>
                </DetailsField>
                <Divider direction="horizontal" />
            </Flexbox>

            <Flexbox direction="column" gap={2} fullWidth justify="space-between">
                <DetailsField fullWidth>
                    <Text palette="neutral" shade="500" size="textSm">
                        {t('projects:behavioral_disorders')}
                    </Text>
                    <Text palette="neutral" shade="950" size="textSm" weight="500">
                        {clinicalRecord.behavioralDisorders
                            ? t(clinicalPresentationToLabel[clinicalRecord.behavioralDisorders])
                            : '-'}
                    </Text>
                </DetailsField>
                <Divider direction="horizontal" />
            </Flexbox>

            <Flexbox direction="column" gap={2} fullWidth justify="space-between">
                <DetailsField fullWidth>
                    <Text palette="neutral" shade="500" size="textSm">
                        {t('projects:communication_disorders')}
                    </Text>
                    <Text palette="neutral" shade="950" size="textSm" weight="500">
                        {clinicalRecord.communicationDisorders
                            ? t(clinicalPresentationToLabel[clinicalRecord.communicationDisorders])
                            : '-'}
                    </Text>
                </DetailsField>
                <Divider direction="horizontal" />
            </Flexbox>

            <DetailsField fullWidth>
                <Text palette="neutral" shade="500" size="textSm">
                    {t('projects:sensory_deficits')}
                </Text>
                <Text palette="neutral" shade="950" size="textSm" weight="500">
                    {clinicalRecord.sensoryDeficit
                        ? t(clinicalPresentationToLabel[clinicalRecord.sensoryDeficit])
                        : '-'}
                </Text>
            </DetailsField>

            <DetailsField fullWidth>
                <Text palette="neutral" shade="500" size="textSm">
                    {t('projects:clinical_stability_level')}
                </Text>
                <Text palette="neutral" shade="950" size="textSm" weight="500">
                    {clinicalRecord.stabilityLevel ? t(stabilityLevelToLabel[clinicalRecord.stabilityLevel]) : '-'}
                </Text>
            </DetailsField>

            <DetailsField fullWidth>
                <Text palette="neutral" shade="500" size="textSm">
                    {t('projects:care_needs')}
                </Text>
                <Text palette="neutral" shade="950" size="textSm" weight="500">
                    {clinicalRecord.careNeeds.length > 0
                        ? clinicalRecord.careNeeds.map(careNeed => t(careNeedToLabel[careNeed.name])).join('; ')
                        : '-'}
                </Text>
            </DetailsField>
        </Grid>
    )
}
